import { SelectOption } from '../models/select-option';

export const MONTH_NAMES = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
] as const;

export const MONTH_NUMBER_OPTIONS: SelectOption<number>[] = MONTH_NAMES.map(
  (monthName, index) => ({
    label: monthName,
    value: index + 1,
  }),
);

export const MONTH_NAME_OPTIONS: SelectOption<string>[] = MONTH_NAMES.map(
  (monthName) => ({
    label: monthName,
    value: monthName,
  }),
);

export const getMonthIndex = (
  name: string | null | undefined,
): number | null => {
  if (!name) return null;

  const index = (MONTH_NAMES as readonly string[]).indexOf(name);
  return index >= 0 ? index + 1 : null; // 1-12
};

export const getMonthName = (num: number | null | undefined): string | null => {
  if (!num || num < 1 || num > 12) return null;

  return MONTH_NAMES[num - 1];
};
